import { render, staticRenderFns } from "./VerifiedAssessmentImportV3.vue?vue&type=template&id=60e5f8ee&scoped=true&"
import script from "./VerifiedAssessmentImportV3.vue?vue&type=script&lang=ts&"
export * from "./VerifiedAssessmentImportV3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e5f8ee",
  null
  
)

export default component.exports